import { useCallback } from "external/react"
import {clsx, styled, Box} from "external/material"
import { centerVertically} from 'utils/style'

const StyledButton = styled(Box)(buttonStyles)

export default function DashboardTodayButton(props) {

    const {label, active, onCalendarChange} = props
    const onClick = useCallback(() => {
        !active && props.onCalendarChange({})
    },[active, onCalendarChange])
    const className = clsx('today', {active})
    return (<StyledButton {...{onClick, className}}>{label}</StyledButton>)
}

function buttonStyles() {
    return {
        ...centerVertically,
        textAlign: 'center',
        backgroundColor: '#fff',
        border: 'solid 1px #5da9ff',
        borderRadius: '4px',
        cursor: 'pointer',
        width: '60px',
        fontSize: '10pt',
        "&:hover": {
            transform: 'scale(1.02)',
            fontWeight: 'bold'
        },
        "&.today": {
            marginRight: '15px',
        },
        "&.active": { 
            cursor: 'default',
            color: '#fff',
            backgroundColor: '#5da9ff',
            "&:hover": {
                fontWeight: 'normal',
                transform: 'scale(1.0)'
            }
        }
    }
}
